<template>
  <v-container v-if="ready">
    <v-card>
      <v-card-title>
        <v-btn @click="handleClickCancelarTudo()" exact icon class="mr-2">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        {{ data.tipo === "E" ? "Entrega" : "Recolhimento" }}
        <v-spacer></v-spacer>
        <v-chip v-if="data.confirmado" color="green" dark label
          >Confirmado</v-chip
        >
      </v-card-title>
      <v-card-text>
        Código: {{ data.id }} <br />
        Tipo: {{ data.tipo === "E" ? "Entrega" : "Recolhimento" }} <br />
        Data de cadastro: {{ data.created_at }} <br />
      </v-card-text>

      <v-data-table
        :headers="headers"
        :items="data.itens"
        :items-per-page="-1"
        disable-pagination
        hide-default-footer
      >
        <template v-slot:item.confirmado="{ item }">
          <v-chip small v-if="item.confirmado" label color="success">
            Confirmado
          </v-chip>
          <v-chip small v-else label>
            Pendente
          </v-chip>
        </template>

        <template v-slot:item.locacao_codigo="{ item }">
          <router-link
            :to="{
              name: 'locacoes_locacao_page',
              params: { codigo: item.locacao_codigo }
            }"
            exact
            v-text="item.locacao_codigo"
          ></router-link>
        </template>

        <template v-slot:item.quantidade="{ item }">
          {{ item.quantidade }}

          <v-btn
            v-if="!item.confirmado"
            @click="$refs.formulario.open(item)"
            icon
            color="primary"
            small
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
        </template>

        <template v-slot:item.data="{ item }">
          {{ formatDate(item.data) }}

          <v-btn
            v-if="!item.confirmado"
            @click="$refs.formularioData.open(item)"
            icon
            color="primary"
            small
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
        </template>

        <template v-slot:item.acoes="{ item }">
          <template v-if="!item.confirmado">
            <v-btn
              @click="handleClickCancelarItem(item)"
              color="red"
              text
              small
            >
              Remover
            </v-btn>
          </template>
        </template>
      </v-data-table>
      <v-divider></v-divider>

      <v-card-actions v-if="!data.confirmado">
        <v-spacer></v-spacer>
        <v-btn
          @click="handleClickCancelarTudo()"
          elevation="0"
          color="red"
          dark
        >
          <v-icon small left>mdi-close</v-icon>
          Cancelar
        </v-btn>
        <v-btn @click="handleClickAprovarTudo()" elevation="0" color="success">
          <v-icon small left>mdi-check-all</v-icon>
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>

    <ConfirmationDialog ref="confirm" />
    <FormularioProdutoDialog ref="formulario" @enviado="refresh()" />
    <FormularioDataDialog ref="formularioData" @enviado="refresh()" />
  </v-container>
</template>

<script>
import locacoes from "@/services/locacoes";
import QueryMixin from "@/mixins/QueryMixin";
import ConfirmationDialog from "@/components/tools/ConfirmationDialog.vue";
import alertsMixin from "@/mixins/alerts";
import FormularioProdutoDialog from "@/components/locacoes/ordensTransporte/FormularioProdutoDialog.vue";
import FormularioDataDialog from "@/components/locacoes/ordensTransporte/FormularioDataDialog.vue";
import dateTimeMixin from "@/mixins/DateTimeMixin";

export default {
  mixins: [QueryMixin, alertsMixin, dateTimeMixin],

  components: {
    ConfirmationDialog,
    FormularioProdutoDialog,
    FormularioDataDialog
  },

  props: {
    codigo: [String, Number]
  },

  data() {
    return {
      headers: [
        {
          text: "Locação",
          value: "locacao_codigo"
        },
        {
          text: "Produto",
          value: "produto_nome"
        },
        {
          text: "Qtd",
          value: "quantidade"
        },
        {
          text: "Data",
          value: "data"
        },
        {
          text: "",
          value: "acoes",
          sortable: false,
          align: "right"
        }
      ]
    };
  },

  methods: {
    handleNotFound() {
      this.retornar();
    },

    retornar() {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.replace("/locações/transportes"); // Substitua pelo seu caminho padrão
      }
    },

    async getData() {
      return await locacoes.ordens_transporte.exibir(this.codigo);
    },

    async handleClickAprovar(item) {
      this.$refs.confirm.confirm(
        "Aprovar item " + item.produto_nome + "?",
        async ({ close, startLoading, stopLoading, setError }) => {
          startLoading();

          try {
            await locacoes.ordens_transporte.confirmarItem(item.id);
            close();
          } catch (error) {
            setError(error.response.data.message);
          } finally {
            stopLoading();
          }
        },
        null,
        {
          confirmText: "Confirmar",
          color: "success"
        }
      );
    },

    async handleClickCancelarItem(item) {
      this.$refs.confirm.confirm(
        "Remover item " + item.produto_nome + "?",
        async ({ close, startLoading, stopLoading, setError }) => {
          startLoading();

          try {
            await locacoes.ordens_transporte.removerItem(item.id);
            close();
            this.refresh();
          } catch (error) {
            setError(error.response.data.message);
          } finally {
            stopLoading();
          }
        },
        null,
        {
          confirmText: "Remover item",
          color: "red"
        }
      );
    },

    async handleClickCancelarTudo() {
      if (this.data.confirmado) {
        this.retornar();
        return;
      }

      this.$refs.confirm.confirm(
        "Cancelar transporte?",
        async ({ close, startLoading, stopLoading, setError }) => {
          startLoading();

          try {
            await locacoes.ordens_transporte.cancelar(this.codigo);
            close();
            this.retornar();
          } catch (error) {
            setError(error.response.data.message);
          } finally {
            stopLoading();
          }
        },
        null,
        {
          confirmText: "Cancelar",
          color: "red"
        }
      );
    },

    async handleClickAprovarTudo() {
      this.$refs.confirm.confirm(
        "Aprovar transporte?",
        async ({ close, startLoading, stopLoading, setError }) => {
          startLoading();

          try {
            await locacoes.ordens_transporte.confirmar(this.codigo);
            close();
            this.retornar();
          } catch (error) {
            setError(error.response.data.message);
          } finally {
            stopLoading();
          }
        },
        null,
        {
          confirmText: "Confirmar",
          color: "success"
        }
      );
    }
  },

  computed: {}
};
</script>
